import { useSentryAsync } from '@/shared/composition/useSentryAsync';
import emitter from '@/shared/services/emitter';
import { captureExceptionSentry } from '@/shared/composition';
import { useUiStore } from '@/shared/store/useUiStore';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';

export let lastErrorCode = 0;

const { captureExceptionSentry } = useSentryAsync();

export default function handleApiError(this: any, error: any, showToast: boolean = true) {
  captureExceptionSentry(error, 'Обраобтка ошибки апи');
  let message = 'Произошла ошибка!';
  const { response } = error;
  if (!response) {
    emitter.emit('createToast', {
      message,
      color: 'error',
    });
  }

  if (response?.data?.message) {
    message += response.data.message;
    emitter.emit('createToast', {
      message,
      color: 'error',
    });
  } else if (response?.data?.error) {
    const { error } = response.data;
    emitter.emit('createToast', {
      message: error,
      color: 'error',
    });
  }

  const errorMessage = error?.response?.data?.error;
  const errorStatus = error?.response?.status;
  if (errorStatus && !CLIENT_STATUSES.includes(errorStatus) && !errorMessage) {
    const uiStore = useUiStore();
    uiStore.enableFatalError();
    console.error(error);
  }

  lastErrorCode = response?.data?.errorCode;
}

export const STATUS_CLIENT_ERROR = 400;
export const STATUS_CLIENT_CONFLICT = 409;
export const STATUS_CLIENT_FORBIDDEN = 403;

export const CLIENT_STATUSES = [
  STATUS_CLIENT_ERROR,
  STATUS_CLIENT_CONFLICT,
  STATUS_CLIENT_FORBIDDEN,
];

export const handleRequestError = (error: any) => {
  const errorMessage = error?.response?.data?.error;
  const errorStatus = error?.response?.status;

  if (CLIENT_STATUSES.includes(errorStatus) && errorMessage) {
    emitter.emit('createToast', {
      message: error.response.data.error,
      color: 'error',
    });
  } else if (errorStatus && !errorMessage) {
    const uiStore = useUiStore();
    uiStore.enableFatalError();
    console.error(error);
  }
};

export const appErrorsGuest = new GuestDynamic(error => {
  handleApiError(error);
});
